import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'flowbite-react';
import { gsap } from 'gsap';
import { Link } from 'react-router-dom';

const Cookies = ({ onCookiePreferenceChange }) => {
    const [cookiesEnabled, setCookiesEnabled] = useState(false);
    const [displayBanner, setDisplayBanner] = useState(true);
    const bannerRef = useRef(null);

    useEffect(() => {
        const cookiesAccepted = localStorage.getItem('cookiesAccepted');
        if (cookiesAccepted !== null) {
            setCookiesEnabled(cookiesAccepted === 'true');
            setDisplayBanner(false);
        } else {
            gsap.fromTo(bannerRef.current, { y: 100, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 });
        }
    }, []);

    function acceptCookies() {
        gsap.to(bannerRef.current, {
            y: 100, opacity: 0, duration: 0.5, onComplete: () => {
                localStorage.setItem('cookiesAccepted', 'true');
                setCookiesEnabled(true);
                setDisplayBanner(false);
                onCookiePreferenceChange(true);
                console.log('Cookies Accepted');
            }
        });
    }

    function declineCookies() {
        gsap.to(bannerRef.current, {
            y: 100, opacity: 0, duration: 0.5, onComplete: () => {
                localStorage.setItem('cookiesAccepted', 'false');
                setCookiesEnabled(false);
                setDisplayBanner(false);
                onCookiePreferenceChange(false);
                console.log('Cookies Declined');
            }
        });
    }

    if (!displayBanner) {
        return null; // Do not display the banner if cookies are already accepted or declined
    }

    return (
        <div ref={bannerRef} className="w-full flex p-2 tablet:p-4 fixed bottom-0 z-[99]">
            <div className="w-full bg-green_s4 rounded-lg p-2 tablet:p-4 custom-shadow">
                <div className="flex flex-col w-full">
                    <div className="flex flex-col w-full tablet:flex-row justify-between items-end tablet:items-end gap-2">
                        <div className="flex flex-col justify-center gap-2 w-full">
                            <h4 className='text-xl tablet:text-2xl font-bold text-white'>Privacy Policy</h4>
                            <p className="text-white text-xs tablet:text-sm ">
                                We use cookies to ensure you get the best experience on our website.{' '}
                                <Link to="/privacy-policy" className="text-white underline">Learn more</Link>
                            </p>
                        </div>
                        <div className="flex flex-row items-center gap-2 w-full tablet:w-auto justify-end">
                            <Button color='dark' size={'sm'} className='w-max' onClick={declineCookies}>Decline Cookies</Button>
                            <Button color='light' size={'sm'} className='w-max' onClick={acceptCookies}>Accept All Cookies</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cookies;
